import {
  PROMOS,
  GEARS_PROMOS,
  LAWBREAKERS_PROMOS,
  RS6_PROMOS
} from "./promoArrays.js";

module.exports.getRandomPromo = function(num) {
    var arr = PROMOS;
    var promo = arr[num.toString()];
    return promo;
}

module.exports.getRandomGears4Promo = function(num) {
    var arr = GEARS_PROMOS;
    var promo = arr[num.toString()];
    return promo;
}

module.exports.getRandomLawBreakersPromo = function(num) {
    var arr = LAWBREAKERS_PROMOS;
    var promo = arr[num.toString()];
    return promo;
}

module.exports.getRandomRS6Promo = function(num) {
    var arr = RS6_PROMOS;
    var promo = arr[num.toString()];
    return promo;
}



// WEBPACK FOOTER //
// ./src/app/utils/promos/promoUtil.js